import PropTypes from 'prop-types';
import { useEffect } from 'react';
import Modal from 'react-modal';
import './ConfirmationModal.css';

const customConfirmationStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    maxWidth: '312px',
    padding: '35px 29px',
    textAlign: 'center',
    transform: 'translate(-50%, -50%)',
  },
  overlay: {
    backgroundColor: 'rgb(0,0,0,0.5)',
    zIndex: '3',
  },
};

const ConfirmationModal = ({
  isOpen,
  handleOnClose,
  handleOnConfirm,
  resourceDescription,
  confirmButtonText,
  iconName,
  customClass,
}) => {
  useEffect(() => {
    Modal.setAppElement('body');
  }, []);

  return (
    <Modal isOpen={isOpen} onRequestClose={() => handleOnClose()} style={customConfirmationStyles}>
      <div className={`confirmation-modal-content ${customClass}`}>
        <div className={`modal-icon ${iconName}`} />
        <h3>Are you sure?</h3>
        <div className="confirm-copy">{resourceDescription}</div>
        <ul className="modal-buttons">
          <li>
            <button type="button" className="btn" onClick={handleOnClose}>
              Cancel
            </button>
          </li>
          <li>
            <button type="button" className="btn btn-strong" onClick={handleOnConfirm}>
              {confirmButtonText}
            </button>
          </li>
        </ul>
      </div>
    </Modal>
  );
};

ConfirmationModal.defaultProps = {
  resourceDescription: 'this item',
  confirmButtonText: 'Delete',
  iconName: 'bin',
  customClass: '',
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  handleOnConfirm: PropTypes.func.isRequired,
  resourceDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmButtonText: PropTypes.string,
  iconName: PropTypes.string,
  customClass: PropTypes.string,
};

export default ConfirmationModal;
